// extracted by mini-css-extract-plugin
export default {"top_pairs_mini_chart":"ihNOj","top_pairs_mini_chart_canvas":"lWtEf"};